<template>
  <LayoutMain>
    <template slot="body">
      <div class="modal__core">
        <div class="modal__header">
          <p class="modal__title">{{ $t("Entrar na conta") }}</p>
        </div>

        <div class="modal__body">
          <div class="columns">
            <div class="column">
              <template v-if="activeForm == 'login'">
                <p class="modal__subtitle">Login</p>

                <form-login
                  @success="handleLoginSuccess"
                  @switchToResetPw="handleSwitchToResetPw"
                />
              </template>

              <template v-else-if="activeForm == 'resetPw'">
                <p class="modal__subtitle">Recuperar Password</p>

                <form-reset-pw
                  @success="handleRecoverPwSuccess"
                  @switchToLogin="handleSwitchToLogin"
                />
              </template>
            </div>

            <div class="column">
              <p class="modal__subtitle">{{ $t("Criar Conta") }}</p>

              <form-register
                v-if="registerState === 'form'"
                @success="handleRegisterSuccess"
              />

              <!-- <div
                class="register_state_info__row"
                v-else-if="registerState === 'awaitingEmailConfirmation'"
              >
                <p class="register_state_info__p u-fwb">
                  {{ $t("Por favor clique no link no email que lhe enviámos") }}
                </p>
                <p class="register_state_info__p">
                  {{
                    $t(
                      "Confirme que é proprietário do endereço de email com que efetuou o registo clicando no link dentro do email que lhe enviámos."
                    )
                  }}
                </p>
                <p class="register_state_info__p">
                  {{ $t("Quando confirmado iniciaremos o seu cálculo.") }}
                </p>
                <p class="register_state_info__p">{{ $t("Obrigado.") }}</p>
                <div class="awaiting_email_confirmation_spinner__container">
                  <app-spinner />
                </div>
              </div> -->

              <div
                class="register_state_info__row"
                v-else-if="registerState === 'emailConfirmation'"
              >
                <p class="register_state_info__p u-fwb">
                  {{ $t("Registo efetuado com sucesso") }}
                </p>
                <p class="register_state_info__p">
                  {{
                    $t(
                      "A equipa Constalica vai validar o seu registo, irá receber um email quando o registo for aceite e depois poderá fazer o login no simulador"
                    )
                  }}
                </p>
                <p class="register_state_info__p">{{ $t("Obrigado.") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </LayoutMain>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";
import FormLogin from "../components/FormLogin";
import FormResetPw from "../components/FormResetPw";
import FormRegister from "../components/FormRegister";

import { asyncDataStatus } from "../mixins";

import LayoutMain from "../layouts/l-main.vue";

export default {
  mixins: [asyncDataStatus],

  components: {
    LayoutMain,
    FormLogin,
    FormResetPw,
    FormRegister,
  },
  data() {
    return {
      activeForm: "login",
      nextLoginAttemptTimeout: null,
      attemptLoginFor: 60 * 1000,
      attemptLoginEvery: 5 * 1000,
      registerState: "form", // 'form' | 'awaitingEmailConfirmation' | 'emailConfirmationSuccess' | 'emailConfirmationFailed'
    };
  },
  computed: {
    ...mapState(["user"]),
  },

  methods: {
    handleSwitchToResetPw() {
      this.activeForm = "resetPw";
    },

    handleSwitchToLogin() {
      this.activeForm = "login";
    },

    handleRegisterSuccess({ email, password }) {
      this.registerState = "emailConfirmation";
      const totalAttempts = this.attemptLoginFor / this.attemptLoginEvery;
      // this.attemptLogin(
      //   { email, password },
      //   totalAttempts,
      //   this.attemptLoginEvery
      // );
    },

    handleLoginSuccess() {
      this.$router.push({ name: "Calculator" });
    },

    handleRecoverPwSuccess() {
      alert("Password enviada para o seu email");
    },

    // attemptLogin({ email, password }, attempts, interval) {
    //   return store
    //     .dispatch("login", {
    //       email,
    //       password,
    //     })
    //     .then(() => {
    //       this.registerState = "emailConfirmationSuccess";
    //       this.handleLoginSuccess();
    //     })
    //     .catch(() => {
    //       if (--attempts) {
    //         this.nextLoginAttemptTimeout = setTimeout(
    //           () => this.attemptLogin({ email, password }, attempts, interval),
    //           interval
    //         );
    //       } else {
    //         //tell user
    //         this.registerState = "emailConfirmationFailed";
    //       }
    //     });
    // },
  },
  created() {
    this.asyncDataStatus_done();
    console.log(this.user);
    if (this.user) {
      this.$router.push({ name: "Calculator" });
    }
  },
};
</script>

<style lang="scss" scoped>
.column-row {
  @include pad("horizontal", 8px);
}

.modal__core {
  position: relative;
  background-color: #fff;
  color: #000;
  padding: 64px 124px 52px;
  max-width: 944px;
  margin: auto;
}
.modal__header {
  margin-bottom: 32px;
}

.modal__title {
  font-family: $font-family-title;
  font-weight: bold;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  font-size: 30px;
  line-height: 1.2;
}

.modal__subtitle {
  @extend .column-row;
  font-family: Titillium Web;
  font-weight: 300;
  font-size: 18px;
  line-height: 27px;
  text-transform: uppercase;
  color: #494949;
  border-bottom: 1px solid #d0d0d0;
  padding: 0 8px;
  margin-bottom: 16px;
}

.modal__body {
  margin-bottom: 2em;
}

.column:first-child {
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: #000;
  }
}

.register_state_info__row {
  @extend .column-row;
  font-size: 14px;
}

.register_state_info__p {
  margin-bottom: 1em;
}

.awaiting_email_confirmation_spinner__container {
  position: relative;
  height: 100px;
}

::v-deep .form {
  @extend .column-row;
}

@media screen and (max-width: 768px) {
  .column:first-child {
    position: relative;
    padding-bottom: 3em;
    margin-bottom: 3em;

    &::after {
      top: 100%;
      width: auto;
      left: 16px;
      right: 16px;
      height: 1px;
    }
  }
}

@media screen and (max-width: 569px) {
  .modal__core {
    padding: 64px 64px 52px;
  }

  .column:first-child {
    position: relative;
    padding-bottom: 3em;
    margin-bottom: 3em;

    &::after {
      top: 100%;
      width: auto;
      left: 16px;
      right: 16px;
      height: 1px;
    }
  }
}

@media screen and (max-width: 569px) {
  .modal__core {
    padding: 64px 32px 52px;
  }
}
</style>
